import { render, staticRenderFns } from "./SchoolManagement.vue?vue&type=template&id=d531c032&scoped=true&"
import script from "./SchoolManagement.vue?vue&type=script&lang=js&"
export * from "./SchoolManagement.vue?vue&type=script&lang=js&"
import style0 from "./SchoolManagement.vue?vue&type=style&index=0&id=d531c032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d531c032",
  null
  
)

export default component.exports